'use client';

import { IconCloseFieldSearch, IconLoupe } from 'components/ui/icons/header';
import styles from './search.module.scss';
import { FC, useEffect, useState } from 'react';
import Link from 'next/link';

interface IProps {
  onClickBurger?: any;
  hiddenInput: boolean;
  setHiddenInput: React.Dispatch<React.SetStateAction<boolean>>;
}

export const Search: FC<IProps> = ({ onClickBurger, hiddenInput, setHiddenInput }) => {
  const [showCloseButton, setShowCloseButton] = useState(true);
  const [sizeWindow, setSizeWindow] = useState(false);
  const [valueSearch, setValueSearch] = useState('');

  useEffect(() => {
    if (valueSearch === '') {
      setShowCloseButton(true);
    } else {
      setShowCloseButton(false);
    }
  }, [valueSearch]);

  useEffect(() => {
    if (window.innerWidth < 640) {
      setSizeWindow(true);
    }
  });

  const showInputSearch = () => {
    setHiddenInput(true);
  };

  const onSubmitForm = (e) => {
    e.preventDefault();
    setValueSearch('');
    setHiddenInput(false);
  };

  const changeValueSearch = ({ target }) => {
    setValueSearch(target.value);
  };

  const cleanFieldSearch = () => {
    setValueSearch('');
    setHiddenInput(false);
  };

  return (
    <article className={styles.searchContainer}>
      {hiddenInput && (
        <form action="#" className={styles.fieldSearch} onSubmit={onSubmitForm}>
          <input type="text" onChange={changeValueSearch} value={valueSearch} />
          {showCloseButton ? (
            <button type="button" className={styles.btnClose} onClick={cleanFieldSearch}>
              <IconCloseFieldSearch />
            </button>
          ) : (
            <Link
              href={`/search/${valueSearch}`}
              onClick={() => {
                if (sizeWindow) {
                  onClickBurger();
                }
              }}
            >
              <button type={'submit'}>
                <IconLoupe width={28} height={28} viewBox={'-6 -6 46 46'} />
              </button>
            </Link>
          )}
        </form>
      )}
      {!hiddenInput && (
        <button className={styles.searchButton} onClick={showInputSearch}>
          <IconLoupe width={28} height={28} viewBox={'-6 -6 46 46'} />
        </button>
      )}
    </article>
  );
};
